import { Earth } from 'ui/svg/icons/Earth'
import { Accordion } from 'ui/svg/icons/venueAndCategories/Accordion'
import { All } from 'ui/svg/icons/venueAndCategories/All'
import { Book } from 'ui/svg/icons/venueAndCategories/Book'
import { Bookstore } from 'ui/svg/icons/venueAndCategories/Bookstore'
import { Brush } from 'ui/svg/icons/venueAndCategories/Brush'
import { Cinema } from 'ui/svg/icons/venueAndCategories/Cinema'
import { Comics } from 'ui/svg/icons/venueAndCategories/Comics'
import { DanceFeet } from 'ui/svg/icons/venueAndCategories/DanceFeet'
import { Detective } from 'ui/svg/icons/venueAndCategories/Detective'
import { Electro } from 'ui/svg/icons/venueAndCategories/Electro'
import { Fantasy } from 'ui/svg/icons/venueAndCategories/Fantasy'
import { Festival } from 'ui/svg/icons/venueAndCategories/Festival'
import { Jazz } from 'ui/svg/icons/venueAndCategories/Jazz'
import { Litterature } from 'ui/svg/icons/venueAndCategories/Litterature'
import { Micro } from 'ui/svg/icons/venueAndCategories/Micro'
import { Microphone } from 'ui/svg/icons/venueAndCategories/Microphone'
import { Museum } from 'ui/svg/icons/venueAndCategories/Museum'
import { Music } from 'ui/svg/icons/venueAndCategories/Music'
import { Opera } from 'ui/svg/icons/venueAndCategories/Opera'
import { Palette } from 'ui/svg/icons/venueAndCategories/Palette'
import { PencilTip } from 'ui/svg/icons/venueAndCategories/PencilTip'
import { PerformingArts } from 'ui/svg/icons/venueAndCategories/PerformingArts'
import { Philosophy } from 'ui/svg/icons/venueAndCategories/Philosophy'
import { Piano } from 'ui/svg/icons/venueAndCategories/Piano'
import { Press } from 'ui/svg/icons/venueAndCategories/Press'
import { PuzzlePiece } from 'ui/svg/icons/venueAndCategories/PuzzlePiece'
import { Rap } from 'ui/svg/icons/venueAndCategories/Rap'
import { Rock } from 'ui/svg/icons/venueAndCategories/Rock'
import { Romance } from 'ui/svg/icons/venueAndCategories/Romance'
import { Show } from 'ui/svg/icons/venueAndCategories/Show'
import { Streaming } from 'ui/svg/icons/venueAndCategories/Streaming'
import { Theater } from 'ui/svg/icons/venueAndCategories/Theater'
import { Turntable } from 'ui/svg/icons/venueAndCategories/Turntable'
import { Video } from 'ui/svg/icons/venueAndCategories/Video'
import { VideoGame } from 'ui/svg/icons/venueAndCategories/VideoGame'
import { Wrong as None } from 'ui/svg/icons/Wrong'

export const culturalSurveyIcons = {
  Accordion,
  All,
  Book,
  Bookstore,
  Brush,
  Cinema,
  Comics,
  DanceFeet,
  Detective,
  Earth,
  Electro,
  Fantasy,
  Festival,
  Jazz,
  Litterature,
  Micro,
  Microphone,
  Museum,
  Music,
  Opera,
  Palette,
  PencilTip,
  PerformingArts,
  Philosophy,
  Piano,
  Press,
  PuzzlePiece,
  Rap,
  Rock,
  Romance,
  Show,
  Streaming,
  Theater,
  Turntable,
  Video,
  VideoGame,
  None,
}
